import CallChatbot from "./CallChatbot";

const CallChatbotConfig = {
	settings: {},
	routes: [
		{
			path: '/chatbot/call',
			component: CallChatbot
		}
	]
};

export default CallChatbotConfig;
